export default __webpack_public_path__ + "static/PaymentsHero-ff7f50ec6a5ab03805a7554f86ce2adb.png";